import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
type InitShimmerProps = {
  /**
   * Reserve the `h-14` `NavigationHeader` takes once it mounts. Until then the header is a portal
   * target that measures 0, so a placeholder rendered before it has to hold that space or the
   * first screen pushes everything down.
   */
  reserveHeader?: boolean;
};

/**
 * Boot placeholder for every stage between mount and the first screen. The bar sizes mirror
 * `PageShell` around a single field (`CollectEmail` / `CollectPhone`) so the swap to the first
 * screen does not resize the flow.
 */
export const InitShimmer = t0 => {
  const $ = _c(6);
  const {
    reserveHeader: t1
  } = t0;
  const reserveHeader = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== reserveHeader) {
    t2 = reserveHeader && <div data-testid="init-shimmer-header-space" className="h-14 shrink-0" />;
    $[0] = reserveHeader;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center gap-2"><Shimmer height="28px" width="180px" /><Shimmer height="20px" width="240px" /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-6 flex-1">{t3}<div className="flex flex-col gap-4 items-start w-full flex-1"><div className="flex flex-col gap-2 w-full"><Shimmer height="20px" width="88px" /><Shimmer height="40px" width="100%" /></div><Shimmer height="40px" width="100%" /></div></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2) {
    t5 = <div data-testid="init-shimmer" className="flex flex-col flex-1">{t2}{t4}</div>;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};